import { useLazyGetImportTemplateQuery } from '../../features/empresas/empresaApi';
import { CircularProgress } from '@mui/joy';
import { useState } from 'react';
import { ErrorMessage } from './ErrorMessage';

export function DownloadImportTemplateButton() {
    const [ getFile, { isLoading }] = useLazyGetImportTemplateQuery();
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const handleDownloadFile = async () => {
        try {
            setErrorMessage(null);

            const file = await getFile().unwrap();

            if(!file) {
                setErrorMessage("No se pudo obtener el archivo. Intente más tarde");
                return;
            }

            const url = window.URL.createObjectURL(file);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "datos_de_empresas_plantilla");
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch {
            setErrorMessage("Ha ocurrido un problema. Intente más tarde");
        }
    }

    return (
        <div 
            className="flex flex-col gap-1 items-start  mt-2 rounded-[3px] py-[3px]">
            {isLoading
            ?
            <div className="flex justify-center w-full">
                <CircularProgress sx={{ 
                    height: 20,
                    width: 20,
                    "--CircularProgress-size": "20px",
                    "--CircularProgress-trackThickness": "3px",
                    "--CircularProgress-progressThickness": "3px"
                }}/>
            </div>
            :
            <div className="flex h-[20px]">
                <div className="w-[10px]"></div>
                <p
                    onClick={handleDownloadFile}
                    className="text-[12px] italic font-semibold text-center hover:underline select-none cursor-pointer">Descargar plantilla</p>
            </div>
            }

            {errorMessage && (
            <div className="w-full">
                <ErrorMessage customMessage>
                    <p className="text-[12px]">{errorMessage}</p>
                </ErrorMessage>
            </div>
            )}
        </div>
    )
}